/**
 * `FormFields` removed: the original (mobile) version of this file imported
 * FormFields from '../../../constants' for four field-name strings
 * (PROVINCE, CITY, COUPON_SEARCH_RANGE, CATEGORIES). That constant doesn't
 * exist in this project (same issue already fixed in EmailPasswordForm).
 * Replaced with local string constants matching the exact field keys used
 * in the customer signup form payload.
 */
const FIELD_PROVINCE = 'province';
const FIELD_CITY = 'city';
const FIELD_COUPON_SEARCH_RANGE = 'coupon_search_range';
const FIELD_CATEGORIES = 'categories';

const HTTP_METHOD_POST = 'post';

// eslint-disable-next-line import/prefer-default-export
export const preparedRequestData = (data, forMethod = HTTP_METHOD_POST) => {
  return Object.keys(data).reduce((result, fieldKey) => {
    switch (fieldKey) {
      case FIELD_PROVINCE:
        // Province is only used to drive the city picker on the client;
        // the API only wants the city, so it's intentionally dropped here.
        return { ...result };
      case FIELD_CITY:
      case FIELD_COUPON_SEARCH_RANGE: {
        const fieldValue =
          forMethod === HTTP_METHOD_POST
            ? (data[fieldKey] && data[fieldKey].id)
            : data[fieldKey];

        // Skip if .id is empty (null, undefined, or empty string)
        if (!fieldValue) {
          return result;
        }

        return { ...result, [fieldKey]: fieldValue };
      }
      case FIELD_CATEGORIES: {
        const filteredCategories = (data[fieldKey] || [])
          .map(opt => (opt && typeof opt === 'object' ? opt.id : opt))
          .filter(id => !!id); // Filter out empty/falsy values

        return {
          ...result,
          [fieldKey]: filteredCategories.length > 0 ? filteredCategories : undefined,
        };
      }
      default:
        return { ...result, [fieldKey]: data[fieldKey] };
    }
  }, {});
};